import { KonkurrencestatusEnum } from './enums/KonkurrencestatusEnum';
import { getSkoleaarFromDate } from './SkoleAar';
export class KonkurrenceFilter {
    public statusList: KonkurrencestatusEnum[];
    public skoleaar: number;
    public search: string;

    constructor() {
        this.statusList = [ KonkurrencestatusEnum.Offentlig, KonkurrencestatusEnum.IkkePubliceret, KonkurrencestatusEnum.Afviklet, KonkurrencestatusEnum.Slettet ];
        this.skoleaar = getSkoleaarFromDate(new Date());
    }
}  


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/KonkurrenceFilter.ts